
const doctorRouter = [
    {
        path:'',
        name:'doctor-index',
        redirect: '/doctor/detail',
        component: () => import(/* webpackChunkName: "about" */ '../views/doctor/index.vue'),
        children:[
            {
                path:'detail',
                name:'doctor-create',
                component: () => import(/* webpackChunkName: "about" */ '../views/doctor/detail.vue')
            },{
                path:'clinicList',
                name:'doctor-clinicList',
                component: () => import(/* webpackChunkName: "about" */ '../views/doctor/clinicList.vue')
            },
        ]
    },{
        path:'clinic/:id',
        name:'doctor-clinic',
        component: () => import(/* webpackChunkName: "about" */ '../views/doctor/clinicDetail.vue')
    }
    //,{
    //     path:'edit/:id',
    //     name:'patient-edit',
    //     component: () => import(/* webpackChunkName: "about" */ '../views/patient/edit.vue')
    // },
    
]
export default doctorRouter